import api from '@/services/api'

export const createNBox = async nbox => {
    try {
        return api.post('n-boxes', nbox)
    } catch (e) {
        console.log(e)
    }
}
